export const TRADES = [
  { value: 'builder_site_supervisor', label: 'Builder / Site Supervisor' },
  { value: 'bricklayer', label: 'Bricklayer / Blocklayer' },
  { value: 'cabinet_maker', label: 'Cabinet Maker / Joiner' },
  { value: 'carpenter', label: 'Carpenter (Framing & Fix)' },
  { value: 'concreter', label: 'Concreter' },
  { value: 'crane_operator', label: 'Crane Operator' },
  { value: 'dogman', label: 'Dogman (Rigger)' },
  { value: 'electrician', label: 'Electrician' },
  { value: 'excavator', label: 'Excavator / Earthworks Contractor' },
  { value: 'floor_installer', label: 'Floor Installer' },
  { value: 'form_worker', label: 'Form Worker' },
  { value: 'glazier', label: 'Glazier' },
  { value: 'hvac', label: 'HVAC Technician (Air Conditioning)' },
  { value: 'landscaper', label: 'Landscaper' },
  { value: 'painter', label: 'Painter' },
  { value: 'plasterer', label: 'Plasterer (Gyprock)' },
  { value: 'plumber', label: 'Plumber' },
  { value: 'roof_carpenter', label: 'Roof Carpenter' },
  { value: 'roof_tiler', label: 'Roof Tiler' },
  { value: 'roofer', label: 'Roofer' },
  { value: 'scaffolder', label: 'Scaffolder' },
  { value: 'surveyor', label: 'Surveyor' },
  { value: 'tiler', label: 'Tiler' },
  { value: 'welder', label: 'Welder / Metal Fabricator' },
  { value: 'other', label: 'Other' },
]

export const TRADE_VALUES = TRADES.map((t) => t.value)
export const TRADE_LABELS = TRADES.map((t) => t.label)

// Enum-style access — Trades.Carpenter, Trades.RoofCarpenter, Trades.Hvac etc.
// Key is the PascalCase version of the value slug: 'roof_carpenter' → 'RoofCarpenter'
const toPascalCase = (slug) =>
  slug.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join('')

export const TradeValues = Object.fromEntries(
  TRADES.map((t) => [toPascalCase(t.value), t.value])
)

export const TRADE_OTHER = TradeValues.Other

export const tradeLabel = (value) => TRADES.find((t) => t.value === value)?.label ?? value
export const tradeLabels = (values = []) => values.map(tradeLabel).join(', ')
export const tradeValue = (label) => TRADES.find((t) => t.label === label)?.value ?? label
